export default {
  'accountandsettings.menuMap.basic': '基本設置',
  'accountandsettings.menuMap.security': '安全設置',
  'accountandsettings.menuMap.binding': '賬號綁定',
  'accountandsettings.menuMap.notification': '新消息通知',
  'accountandsettings.basic.avatar': '頭像',
  'accountandsettings.basic.change-avatar': '更換頭像',
  'accountandsettings.basic.email': '郵箱',
  'accountandsettings.basic.email-message': '請輸入您的郵箱!',
  'accountandsettings.basic.nickname': '昵稱',
  'accountandsettings.basic.nickname-message': '請輸入您的昵稱!',
  'accountandsettings.basic.profile': '個人簡介',
  'accountandsettings.basic.profile-message': '請輸入個人簡介!',
  'accountandsettings.basic.profile-placeholder': '個人簡介',
  'accountandsettings.basic.country': '國家/地區',
  'accountandsettings.basic.country-message': '請輸入您的國家或地區!',
  'accountandsettings.basic.geographic': '所在省市',
  'accountandsettings.basic.geographic-message': '請輸入您的所在省市!',
  'accountandsettings.basic.address': '街道地址',
  'accountandsettings.basic.address-message': '請輸入您的街道地址!',
  'accountandsettings.basic.phone': '聯系電話',
  'accountandsettings.basic.phone-message': '請輸入您的聯系電話!',
  'accountandsettings.basic.update': '更新基本信息',
  'accountandsettings.basic.update.success': '更新基本信息成功',
  'accountandsettings.security.strong': '強',
  'accountandsettings.security.medium': '中',
  'accountandsettings.security.weak': '弱',
  'accountandsettings.security.password': '賬戶密碼',
  'accountandsettings.security.password-description': '當前密碼強度：',
  'accountandsettings.security.phone': '密保手機',
  'accountandsettings.security.phone-description': '已綁定手機：',
  'accountandsettings.security.question': '密保問題',
  'accountandsettings.security.question-description': '未設置密保問題，密保問題可有效保護賬戶安全',
  'accountandsettings.security.email': '備用郵箱',
  'accountandsettings.security.email-description': '已綁定郵箱：',
  'accountandsettings.security.mfa': 'MFA 設備',
  'accountandsettings.security.mfa-description': '未綁定 MFA 設備，綁定後，可以進行二次確認',
  'accountandsettings.security.modify': '修改',
  'accountandsettings.security.set': '設置',
  'accountandsettings.security.bind': '綁定',
  'accountandsettings.binding.taobao': '綁定淘寶',
  'accountandsettings.binding.taobao-description': '當前未綁定淘寶賬號',
  'accountandsettings.binding.alipay': '綁定支付寶',
  'accountandsettings.binding.alipay-description': '當前未綁定支付寶賬號',
  'accountandsettings.binding.dingding': '綁定釘釘',
  'accountandsettings.binding.dingding-description': '當前未綁定釘釘賬號',
  'accountandsettings.binding.bind': '綁定',
  'accountandsettings.notification.password': '賬戶密碼',
  'accountandsettings.notification.password-description': '其他用戶的消息將以站內信的形式通知',
  'accountandsettings.notification.messages': '系統消息',
  'accountandsettings.notification.messages-description': '系統消息將以站內信的形式通知',
  'accountandsettings.notification.todo': '待辦任務',
  'accountandsettings.notification.todo-description': '待辦任務將以站內信的形式通知',
  'accountandsettings.settings.open': '開',
  'accountandsettings.settings.close': '關',
};
